import ForgotPasswordComponent from '../components/forgot-password';

function ForgotPassword () {
  return (
    <ForgotPasswordComponent />
  );
}

export default ForgotPassword;
